document.addEventListener('DOMContentLoaded', function () {
  initIndexCustomBanners();
  initCustomCollectionSlides();
  initCustomFeaturedCollectionOnes();
  initCustomFeaturedCollectionTwos();
  initCustomRecommendedProducts();
  initIndexFaqs();
  initCustomFaqPages();
  initProductEnquiryButtons();
});

document.addEventListener('shopify:section:load', function (event) {
  initIndexCustomBanners(event.target);
  initCustomCollectionSlides(event.target);
  initCustomFeaturedCollectionOnes(event.target);
  initCustomFeaturedCollectionTwos(event.target);
  initCustomRecommendedProducts(event.target);
  initIndexFaqs(event.target);
  initCustomFaqPages(event.target);
  initProductEnquiryButtons(event.target);
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    initProductEnquiryButtons(event && event.data ? document.getElementById('MainProduct-' + event.data.sectionId) : document);
  });
}

document.addEventListener('shopify:block:select', function (event) {
  var banner = event.target.closest('[data-index-custom-banner]');

  if (banner && banner.indexCustomBannerSlider) {
    var bannerSlide = event.target.closest('.splide__slide');
    if (bannerSlide) {
      banner.indexCustomBannerSlider.go(Number(bannerSlide.dataset.slideIndex || 0));
    }
  }

  var collectionSlide = event.target.closest('[data-custom-collection-slide]');

  if (collectionSlide && collectionSlide.customCollectionSlider) {
    var collectionItem = event.target.closest('.splide__slide');
    if (collectionItem) {
      collectionSlide.customCollectionSlider.go(Number(collectionItem.dataset.slideIndex || 0));
    }
  }

  var featuredCollection = event.target.closest('[data-custom-featured-collection-1]');

  if (featuredCollection && featuredCollection.customFeaturedCollectionOneSlider) {
    var featuredItem = event.target.closest('.splide__slide');
    if (featuredItem) {
      featuredCollection.customFeaturedCollectionOneSlider.go(Number(featuredItem.dataset.slideIndex || 0));
    }
  }

  var featuredCollectionTwo = event.target.closest('[data-custom-featured-collection-2]');

  if (featuredCollectionTwo && featuredCollectionTwo.customFeaturedCollectionTwoSlider) {
    var featuredItemTwo = event.target.closest('.splide__slide');
    if (featuredItemTwo) {
      featuredCollectionTwo.customFeaturedCollectionTwoSlider.go(Number(featuredItemTwo.dataset.slideIndex || 0));
    }
  }
});

function initIndexCustomBanners(scope) {
  if (typeof Splide === 'undefined') {
    return;
  }

  var container = scope || document;
  var banners = container.querySelectorAll('[data-index-custom-banner]');

  banners.forEach(function (banner) {
    if (banner.indexCustomBannerSlider) {
      banner.indexCustomBannerSlider.destroy(true);
    }

    var slider = banner.querySelector('.index-custom-banner__slider');
    var slides = banner.querySelectorAll('.splide__slide');

    if (!slider || !slides.length) {
      return;
    }

    slides.forEach(function (slide, index) {
      slide.dataset.slideIndex = index;
    });

    var autoplay = banner.dataset.autoplay === 'true' && slides.length > 1;
    var interval = Number(banner.dataset.interval) || 5000;
    var speed = Number(banner.dataset.speed) || 700;

    banner.indexCustomBannerSlider = new Splide(slider, {
      type: slides.length > 1 ? 'loop' : 'slide',
      arrows: false,
      pagination: slides.length > 1,
      autoplay: autoplay,
      interval: interval,
      speed: speed,
      rewind: slides.length <= 1,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: slides.length > 1,
      perPage: 1,
      perMove: 1,
      gap: 0,
      keyboard: 'focused',
      classes: {
        pagination: 'splide__pagination index-custom-banner__pagination',
        page: 'splide__pagination__page index-custom-banner__pagination-page'
      }
    });

    banner.indexCustomBannerSlider.mount();
  });
}

function initCustomCollectionSlides(scope) {
  if (typeof Splide === 'undefined') {
    return;
  }

  var container = scope || document;
  var sections = container.querySelectorAll('[data-custom-collection-slide]');

  sections.forEach(function (section) {
    if (section.customCollectionSlider) {
      section.customCollectionSlider.destroy(true);
    }

    var slider = section.querySelector('.custom-collection-slide__slider');
    var slides = section.querySelectorAll('.splide__slide');

    if (!slider || !slides.length) {
      return;
    }

    slides.forEach(function (slide, index) {
      slide.dataset.slideIndex = index;
    });

    var desktopPerPage = Number(section.dataset.desktopPerPage) || 5;
    var tabletPerPage = Number(section.dataset.tabletPerPage) || 3;
    var mobilePerPage = Number(section.dataset.mobilePerPage) || 1;
    var autoplay = section.dataset.autoplay === 'true' && slides.length > desktopPerPage;
    var interval = Number(section.dataset.interval) || 5000;
    var speed = Number(section.dataset.speed) || 700;

    section.customCollectionSlider = new Splide(slider, {
      type: slides.length > desktopPerPage ? 'loop' : 'slide',
      arrows: slides.length > desktopPerPage,
      pagination: false,
      autoplay: autoplay,
      interval: interval,
      speed: speed,
      rewind: slides.length <= desktopPerPage,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: slides.length > desktopPerPage,
      perPage: desktopPerPage,
      perMove: 1,
      gap: '2rem',
      keyboard: 'focused',
      breakpoints: {
        989: {
          perPage: tabletPerPage,
          arrows: slides.length > tabletPerPage,
          drag: slides.length > tabletPerPage
        },
        749: {
          perPage: mobilePerPage,
          arrows: slides.length > mobilePerPage,
          drag: slides.length > mobilePerPage,
          gap: '1.6rem'
        }
      }
    });

    section.customCollectionSlider.mount();
  });
}

function initCustomFeaturedCollectionOnes(scope) {
  if (typeof Splide === 'undefined') {
    return;
  }

  var container = scope || document;
  var sections = container.querySelectorAll('[data-custom-featured-collection-1]');

  sections.forEach(function (section) {
    if (section.customFeaturedCollectionOneSlider) {
      section.customFeaturedCollectionOneSlider.destroy(true);
    }

    var slider = section.querySelector('.custom-featured-collection-1__slider');
    var slides = section.querySelectorAll('.splide__slide');

    if (!slider || !slides.length) {
      return;
    }

    slides.forEach(function (slide, index) {
      slide.dataset.slideIndex = index;
    });

    var desktopPerPage = Number(section.dataset.desktopPerPage) || 4;
    var tabletPerPage = Number(section.dataset.tabletPerPage) || 2;
    var mobilePerPage = Number(section.dataset.mobilePerPage) || 1;
    var autoplay = section.dataset.autoplay === 'true' && slides.length > desktopPerPage;
    var interval = Number(section.dataset.interval) || 5000;
    var speed = Number(section.dataset.speed) || 700;

    section.customFeaturedCollectionOneSlider = new Splide(slider, {
      type: slides.length > desktopPerPage ? 'loop' : 'slide',
      arrows: slides.length > desktopPerPage,
      pagination: false,
      autoplay: autoplay,
      interval: interval,
      speed: speed,
      rewind: slides.length <= desktopPerPage,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: slides.length > desktopPerPage,
      perPage: desktopPerPage,
      perMove: 1,
      gap: '2rem',
      keyboard: 'focused',
      breakpoints: {
        989: {
          perPage: tabletPerPage,
          arrows: slides.length > tabletPerPage,
          drag: slides.length > tabletPerPage
        },
        749: {
          perPage: mobilePerPage,
          arrows: slides.length > mobilePerPage,
          drag: slides.length > mobilePerPage,
          gap: '1.6rem'
        }
      }
    });

    section.customFeaturedCollectionOneSlider.mount();
  });
}

function initCustomFeaturedCollectionTwos(scope) {
  if (typeof Splide === 'undefined') {
    return;
  }

  var container = scope || document;
  var sections = container.querySelectorAll('[data-custom-featured-collection-2]');

  sections.forEach(function (section) {
    if (section.customFeaturedCollectionTwoSlider) {
      section.customFeaturedCollectionTwoSlider.destroy(true);
    }

    var slider = section.querySelector('.custom-featured-collection-2__slider');
    var slides = section.querySelectorAll('.splide__slide');

    if (!slider || !slides.length) {
      return;
    }

    slides.forEach(function (slide, index) {
      slide.dataset.slideIndex = index;
    });

    var desktopPerPage = Number(section.dataset.desktopPerPage) || 3;
    var tabletPerPage = Number(section.dataset.tabletPerPage) || 2;
    var mobilePerPage = Number(section.dataset.mobilePerPage) || 1;
    var autoplay = section.dataset.autoplay === 'true' && slides.length > desktopPerPage;
    var interval = Number(section.dataset.interval) || 5000;
    var speed = Number(section.dataset.speed) || 700;

    section.customFeaturedCollectionTwoSlider = new Splide(slider, {
      type: slides.length > desktopPerPage ? 'loop' : 'slide',
      arrows: slides.length > desktopPerPage,
      pagination: false,
      autoplay: autoplay,
      interval: interval,
      speed: speed,
      rewind: slides.length <= desktopPerPage,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: slides.length > desktopPerPage,
      perPage: desktopPerPage,
      perMove: 1,
      gap: '2rem',
      keyboard: 'focused',
      breakpoints: {
        989: {
          perPage: tabletPerPage,
          arrows: slides.length > tabletPerPage,
          drag: slides.length > tabletPerPage
        },
        749: {
          perPage: mobilePerPage,
          arrows: slides.length > mobilePerPage,
          drag: slides.length > mobilePerPage,
          gap: '1.6rem'
        }
      }
    });

    section.customFeaturedCollectionTwoSlider.mount();
  });
}

function initCustomRecommendedProducts(scope) {
  var container = scope || document;
  var sections = container.querySelectorAll('[data-custom-recommended]');

  sections.forEach(function (section) {
    var recommendations = section.querySelector('product-recommendations');

    function mountSlider() {
      if (typeof Splide === 'undefined') {
        return;
      }

      var slider = section.querySelector('.custom-recommended__slider');
      var slides = section.querySelectorAll('.custom-recommended__item.splide__slide:not(.splide__slide--clone)');

      if (!slider || !slides.length) {
        return false;
      }

      if (section.customRecommendedSlider && section.customRecommendedSlideCount === slides.length) {
        return true;
      }

      if (section.customRecommendedSlider) {
        section.customRecommendedSlider.destroy(true);
        section.customRecommendedSlider = null;
      }

      slides.forEach(function (slide, index) {
        slide.dataset.slideIndex = index;
      });

      var desktopPerPage = Number(section.dataset.desktopPerPage) || 3;
      var tabletPerPage = Number(section.dataset.tabletPerPage) || 2;
      var mobilePerPage = Number(section.dataset.mobilePerPage) || 1;
      var autoplay = section.dataset.autoplay === 'true' && slides.length > desktopPerPage;
      var interval = Number(section.dataset.interval) || 5000;
      var speed = Number(section.dataset.speed) || 700;

      section.customRecommendedSlider = new Splide(slider, {
        type: slides.length > desktopPerPage ? 'loop' : 'slide',
        arrows: slides.length > desktopPerPage,
        pagination: false,
        autoplay: autoplay,
        interval: interval,
        speed: speed,
        rewind: slides.length <= desktopPerPage,
        pauseOnHover: true,
        pauseOnFocus: true,
        drag: slides.length > desktopPerPage,
        perPage: desktopPerPage,
        perMove: 1,
        gap: '2rem',
        keyboard: 'focused',
        breakpoints: {
          989: {
            perPage: tabletPerPage,
            arrows: slides.length > tabletPerPage,
            drag: slides.length > tabletPerPage
          },
          749: {
            perPage: mobilePerPage,
            arrows: slides.length > mobilePerPage,
            drag: slides.length > mobilePerPage,
            gap: '1.6rem'
          }
        }
      });

      section.customRecommendedSlider.mount();
      section.customRecommendedSlideCount = slides.length;

      return true;
    }

    var isMounted = mountSlider();

    if (recommendations && !section.customRecommendedObserver && !isMounted) {
      section.customRecommendedObserver = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          var mounted = mountSlider();

          if (mounted && section.customRecommendedObserver) {
            section.customRecommendedObserver.disconnect();
            section.customRecommendedObserver = null;
          }
        });
      });

      section.customRecommendedObserver.observe(recommendations, {
        childList: true
      });
    }
  });
}

function initIndexFaqs(scope) {
  var container = scope || document;
  var faqSections = container.querySelectorAll('[data-index-faq]');

  faqSections.forEach(function (section) {
    var items = section.querySelectorAll('.index-faq__item');

    function setFaqState(item, shouldOpen) {
      var button = item.querySelector('.index-faq__question');
      var answer = item.querySelector('.index-faq__answer');

      item.classList.toggle('is-open', shouldOpen);

      if (button) {
        button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      if (answer) {
        answer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
        answer.style.height = shouldOpen ? answer.scrollHeight + 'px' : '0px';
      }
    }

    items.forEach(function (item) {
      setFaqState(item, item.classList.contains('is-open'));
    });

    items.forEach(function (item) {
      var button = item.querySelector('.index-faq__question');
      var answer = item.querySelector('.index-faq__answer');

      if (!button || !answer || button.indexFaqBound) {
        return;
      }

      button.indexFaqBound = true;

      button.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          setFaqState(otherItem, !wasOpen && otherItem === item);
        });
      });
    });

    if (!section.indexFaqResizeBound) {
      section.indexFaqResizeBound = true;

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) {
            setFaqState(item, true);
          }
        });
      });
    }
  });
}

function initCustomFaqPages(scope) {
  var container = scope || document;
  var faqPages = container.querySelectorAll('[data-custom-faq-page]');

  faqPages.forEach(function (section) {
    var items = section.querySelectorAll('.custom-faq-page__item');
    var links = section.querySelectorAll('[data-custom-faq-link]');

    function setFaqState(item, shouldOpen) {
      var button = item.querySelector('.custom-faq-page__question');
      var answer = item.querySelector('.custom-faq-page__answer');

      item.classList.toggle('is-open', shouldOpen);

      if (button) {
        button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      if (answer) {
        answer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
        answer.style.height = shouldOpen ? answer.scrollHeight + 'px' : '0px';
      }
    }

    function setActiveCategory(category) {
      links.forEach(function (link) {
        var target = link.getAttribute('href') || '';
        link.classList.toggle('is-active', target.indexOf(category) !== -1);
      });
    }

    items.forEach(function (item) {
      setFaqState(item, item.classList.contains('is-open'));
    });

    items.forEach(function (item) {
      var button = item.querySelector('.custom-faq-page__question');

      if (!button || button.customFaqPageBound) {
        return;
      }

      button.customFaqPageBound = true;

      button.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        var group = item.closest('.custom-faq-page__group');
        var groupItems = group ? group.querySelectorAll('.custom-faq-page__item') : [item];

        groupItems.forEach(function (groupItem) {
          setFaqState(groupItem, !wasOpen && groupItem === item);
        });
      });
    });

    links.forEach(function (link) {
      if (link.customFaqPageBound) {
        return;
      }

      link.customFaqPageBound = true;

      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        var targetId = href ? href.replace('#', '') : '';
        var target = targetId ? document.getElementById(targetId) : null;

        if (!target) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveCategory(target.dataset.category);
      });
    });

    if (!section.customFaqPageResizeBound) {
      section.customFaqPageResizeBound = true;

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) {
            setFaqState(item, true);
          }
        });
      });
    }
  });
}

function initProductEnquiryButtons(scope) {
  var container = scope || document;
  var forms = container.querySelectorAll('.product-form');

  forms.forEach(function (form) {
    var submitButton = form.querySelector('.product-form__submit');
    var enquiryButton = form.querySelector('.product-form__enquire');

    if (!submitButton || !enquiryButton) {
      return;
    }

    var shouldShowEnquiry = submitButton.hasAttribute('disabled');

    submitButton.classList.toggle('product-form__submit--hide-soldout', shouldShowEnquiry);
    enquiryButton.classList.toggle('hidden', !shouldShowEnquiry);
  });
}
